import script from "./VerticalSectionSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./VerticalSectionSelector.vue?vue&type=script&lang=ts&setup=true"

import "./VerticalSectionSelector.vue?vue&type=style&index=0&id=450ce288&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450ce288"]])

export default __exports__